module.exports = __webpack_public_path__ + "img/boston.b07a366b.jpg";